import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Preloader = (props) => (
	<div className={cn('preloader-wrap', {'absolute': props.isInContainer})}><div className="preloader"></div></div>
);

Preloader.propTypes = {
	isInContainer: PropTypes.bool
}

export default Preloader;



// WEBPACK FOOTER //
// ./components/Preloader.js